export default __webpack_public_path__ + "static/3d6f13177ada9c62a55a7df90e0e8ce5.jpg";